__turbopack_context__.v({
  "variantContainer": "KaDqkW_variantContainer",
});
